module.exports = __webpack_public_path__ + "img/zt.8368ca22.png";